/* ============================================================
   Kruncho PDP — flavor tabs, per-card quantity stepper,
   offers strip auto-scroll.

   Talks to Shopify's real cart, so quantities survive a reload
   and always match what is actually in the cart.

   THIS IS JAVASCRIPT. It belongs in assets/kruncho-pdp.js only.
   ============================================================ */

(function () {
  // Snippets may render more than once on a page (e.g. two Custom Liquid
  // blocks). This guard stops the listeners binding twice, which would
  // otherwise change the quantity by two per click.
  if (window.__krunchoPdpInit) return;
  window.__krunchoPdpInit = true;

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // variantId -> { qty, key }.  The line item key is what /cart/change.js
  // wants; variant id alone is ambiguous once a variant appears on more
  // than one line (different properties, selling plans, etc).
  var cartByVariant = {};

  function money(cents) {
    try {
      return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
    } catch (e) {
      return '₹' + Math.round(cents / 100);
    }
  }

  function showError(scope, message) {
    var box = (scope || document).querySelector('[data-kr-error]');
    if (box) box.textContent = message || '';
  }

  /* ---------- Tabs ---------- */

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.kr-tab');
    if (!tab) return;

    var scope = tab.closest('.kr-flavors');
    if (!scope) return;

    var group = tab.getAttribute('data-kr-tab');

    scope.querySelectorAll('.kr-tab').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    scope.querySelectorAll('.kr-flavor-grid').forEach(function (grid) {
      grid.hidden = grid.getAttribute('data-kr-group') !== group;
    });
  });

  /* ---------- Quantity stepper ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kr-plus], [data-kr-minus]');
    if (!btn || btn.disabled) return;

    e.preventDefault();

    var stepper = btn.closest('.kr-qty');
    if (!stepper) return;

    var variantId = Number(stepper.getAttribute('data-variant-id'));
    if (!variantId) return;

    var isPlus = btn.hasAttribute('data-kr-plus');
    var line = cartByVariant[variantId];
    var currentQty = line ? line.qty : 0;

    if (!isPlus && currentQty <= 0) return;

    var scope = stepper.closest('.kr-flavors');
    showError(scope, '');
    stepper.classList.add('is-loading');

    var request;

    if (isPlus && currentQty === 0) {
      // Not in the cart yet, so this is an add rather than a change.
      request = fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
    } else {
      request = fetch(routeRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: isPlus ? currentQty + 1 : currentQty - 1 })
      });
    }

    request
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
          return data;
        });
      })
      .then(function () {
        return refreshCart();
      })
      .catch(function (err) {
        showError(scope, err.message || 'Could not update the cart. Please try again.');
      })
      .then(function () {
        stepper.classList.remove('is-loading');
      });
  });

  /* ---------- Read the real cart and paint the UI from it ---------- */

  function refreshCart() {
    return fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        cartByVariant = {};
        (cart.items || []).forEach(function (item) {
          var existing = cartByVariant[item.variant_id];
          cartByVariant[item.variant_id] = {
            qty: (existing ? existing.qty : 0) + item.quantity,
            key: existing ? existing.key : item.key
          };
        });

        document.querySelectorAll('.kr-qty').forEach(function (stepper) {
          var line = cartByVariant[Number(stepper.getAttribute('data-variant-id'))];
          var qty = line ? line.qty : 0;

          stepper.classList.toggle('is-in-cart', qty > 0);

          var val = stepper.querySelector('[data-kr-qty]');
          if (val) val.textContent = qty;

          var minus = stepper.querySelector('[data-kr-minus]');
          if (minus) minus.disabled = qty <= 0;
        });

        document.querySelectorAll('.kr-cart-summary').forEach(function (bar) {
          var text = bar.querySelector('[data-kr-summary-text]');
          if (cart.item_count > 0) {
            bar.classList.add('is-show');
            if (text) {
              text.textContent =
                '🛒 ' + cart.item_count + ' item' + (cart.item_count > 1 ? 's' : '') + ' · ' + money(cart.total_price);
            }
          } else {
            bar.classList.remove('is-show');
          }
        });

        return updateHeaderCount();
      })
      .catch(function () {
        /* Cart read failed — leave the UI as it is rather than blanking it. */
      });
  }

  // Keeps the header cart bubble in sync. Wrapped defensively because this
  // markup differs between themes, and a miss here should never break the
  // stepper itself.
  function updateHeaderCount() {
    return fetch(routeRoot + '?sections=cart-icon-bubble')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var html = sections['cart-icon-bubble'];
        if (!html) return;
        var target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('cart-icon-bubble');
        if (fresh) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- Offers strip: gentle auto-scroll ---------- */

  // Nudges scrollLeft rather than using a CSS marquee, so the strip stays a
  // normal scrollable element — swiping, scrollbars and keyboard scrolling
  // all keep working while it drifts.
  function startAutoScroll(strip) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var paused = false;
    var resumeTimer;

    function pauseFor(ms) {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, ms);
    }

    strip.addEventListener('mouseenter', function () { paused = true; });
    strip.addEventListener('mouseleave', function () { paused = false; });
    strip.addEventListener('focusin', function () { paused = true; });
    strip.addEventListener('touchstart', function () { pauseFor(4000); }, { passive: true });
    strip.addEventListener('wheel', function () { pauseFor(4000); }, { passive: true });

    setInterval(function () {
      if (paused || document.hidden) return;

      var maxScroll = strip.scrollWidth - strip.clientWidth;
      if (maxScroll <= 0) return; // all cards already fit, nothing to scroll

      if (strip.scrollLeft >= maxScroll - 1) {
        strip.scrollTo({ left: 0, behavior: 'smooth' });
        pauseFor(1200); // hold a beat after looping back to the start
      } else {
        strip.scrollLeft += 1;
      }
    }, 30);
  }

  function initOffers() {
    document.querySelectorAll('.kr-offers-scroll').forEach(function (strip) {
      if (strip.dataset.krAutoscroll) return;
      strip.dataset.krAutoscroll = '1';
      startAutoScroll(strip);
    });
  }

  /* ---------- Start everything ---------- */

  function init() {
    initOffers();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders blocks without a page reload.
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
   Kruncho — Frequently Bought Together bundle
   Same file: assets/kruncho-pdp.js (appended, not a new file)
   ============================================================ */

(function () {
  if (window.__krBundleInit) return;
  window.__krBundleInit = true;

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    try {
      return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
    } catch (e) {
      return '₹' + Math.round(cents / 100);
    }
  }

  function rowPrices(row) {
    var select = row.querySelector('[data-kr-bundle-variant]');
    var price, compareAt;

    if (select) {
      var opt = select.options[select.selectedIndex];
      price = Number(opt.getAttribute('data-price')) || 0;
      compareAt = Number(opt.getAttribute('data-compare-at-price')) || price;
    } else {
      // Single-variant product: read the numbers already printed on the row.
      var nowEl = row.querySelector('[data-kr-bundle-now]');
      var wasEl = row.querySelector('[data-kr-bundle-was]');
      price = nowEl ? parseFloat(nowEl.textContent.replace(/[^0-9.]/g, '')) * 100 : 0;
      compareAt = wasEl ? parseFloat(wasEl.textContent.replace(/[^0-9.]/g, '')) * 100 : price;
    }

    return { price: price, compareAt: compareAt };
  }

  function updateRowDisplay(row) {
    var prices = rowPrices(row);
    var nowEl = row.querySelector('[data-kr-bundle-now]');
    var wasEl = row.querySelector('[data-kr-bundle-was]');
    if (nowEl) nowEl.textContent = money(prices.price);
    if (wasEl) {
      if (prices.compareAt > prices.price) {
        wasEl.hidden = false;
        wasEl.textContent = money(prices.compareAt);
      } else {
        wasEl.hidden = true;
      }
    }
  }

  function updateBundleTotal(bundle) {
    var total = 0;
    var totalWas = 0;

    bundle.querySelectorAll('[data-kr-bundle-row]').forEach(function (row) {
      if (row.getAttribute('data-kr-bundle-included') !== 'true') return;
      var prices = rowPrices(row);
      total += prices.price;
      totalWas += prices.compareAt;
    });

    var totalEl = bundle.querySelector('[data-kr-bundle-total]');
    var totalWasEl = bundle.querySelector('[data-kr-bundle-total-was]');
    var savedEl = bundle.querySelector('[data-kr-bundle-saved]');

    if (totalEl) totalEl.textContent = money(total);

    if (totalWasEl) {
      if (totalWas > total) {
        totalWasEl.hidden = false;
        totalWasEl.textContent = money(totalWas);
      } else {
        totalWasEl.hidden = true;
      }
    }

    if (savedEl) {
      var saved = totalWas - total;
      if (saved > 0) {
        savedEl.hidden = false;
        savedEl.textContent = 'You save ' + money(saved);
      } else {
        savedEl.hidden = true;
      }
    }

    var addBtn = bundle.querySelector('[data-kr-bundle-add]');
    if (addBtn) {
      var anyIncluded = Array.prototype.some.call(
        bundle.querySelectorAll('[data-kr-bundle-row]'),
        function (row) { return row.getAttribute('data-kr-bundle-included') === 'true'; }
      );
      addBtn.disabled = !anyIncluded;
    }
  }

  /* Toggle a row in/out of the bundle */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-kr-bundle-toggle]');
    if (!toggle) return;

    var row = toggle.closest('[data-kr-bundle-row]');
    if (!row || row.hasAttribute('data-kr-bundle-locked')) return;

    var included = row.getAttribute('data-kr-bundle-included') === 'true';
    row.setAttribute('data-kr-bundle-included', included ? 'false' : 'true');
    toggle.textContent = included ? 'Add' : 'Selected';

    var bundle = row.closest('[data-kr-bundle]');
    if (bundle) updateBundleTotal(bundle);
  });

  /* Variant change updates that row's price and the running total */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-kr-bundle-variant]');
    if (!select) return;

    var row = select.closest('[data-kr-bundle-row]');
    if (!row) return;

    updateRowDisplay(row);

    var bundle = row.closest('[data-kr-bundle]');
    if (bundle) updateBundleTotal(bundle);
  });

  /* Add every included row to the real cart in one request */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-kr-bundle-add]');
    if (!addBtn || addBtn.disabled) return;

    var bundle = addBtn.closest('[data-kr-bundle]');
    if (!bundle) return;

    var items = [];
    bundle.querySelectorAll('[data-kr-bundle-row]').forEach(function (row) {
      if (row.getAttribute('data-kr-bundle-included') !== 'true') return;
      var select = row.querySelector('[data-kr-bundle-variant]');
      var variantId = select
        ? Number(select.value)
        : Number((row.querySelector('option[selected]') || {}).value);
      if (!variantId) return;
      items.push({ id: variantId, quantity: 1 });
    });

    if (items.length === 0) return;

    var errorBox = bundle.querySelector('[data-kr-error]');
    if (errorBox) errorBox.textContent = '';
    addBtn.disabled = true;
    var originalLabel = addBtn.textContent;
    addBtn.textContent = 'Adding…';

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add the bundle to cart.');
          return data;
        });
      })
      .then(function () {
        window.location.href = routeRoot + 'cart';
      })
      .catch(function (err) {
        if (errorBox) errorBox.textContent = err.message || 'Could not add the bundle to cart. Please try again.';
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
      });
  });

  /* Paint every bundle's starting totals on load */
  function initBundles() {
    document.querySelectorAll('[data-kr-bundle]').forEach(updateBundleTotal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundles);
  } else {
    initBundles();
  }

  document.addEventListener('shopify:section:load', initBundles);
})();/* ============================================================
   Kruncho — Description "Read more / Read less" toggle
   Same file: assets/kruncho-pdp.js (appended)
   Works with the theme's native Description block — no Liquid
   edit needed there since native blocks can't hold custom code.
   ============================================================ */

(function () {
  function initDescriptionToggle() {
    document.querySelectorAll('.product__description').forEach(function (desc) {
      if (desc.dataset.krDescInit) return;
      desc.dataset.krDescInit = '1';

      // Only collapse if the text is actually long enough to need it.
      if (desc.scrollHeight <= 260) return;

      desc.classList.add('kr-desc-collapsed');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kr-desc-toggle';
      btn.textContent = 'Read more';

      btn.addEventListener('click', function () {
        var collapsed = desc.classList.toggle('kr-desc-collapsed');
        btn.textContent = collapsed ? 'Read more' : 'Read less';
      });

      desc.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptionToggle);
  } else {
    initDescriptionToggle();
  }

  document.addEventListener('shopify:section:load', initDescriptionToggle);
})();/* ============================================================
   Kruncho — Frequently Bought Together (kr-fbt) logic
   Handles: live total price + Add selected to cart (AJAX)
   ============================================================ */

(function () {
  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function parsePriceToCents(text) {
    var num = parseFloat(String(text).replace(/[^0-9.]/g, ''));
    return isNaN(num) ? 0 : Math.round(num * 100);
  }

  function initFbt(fbt) {
    if (fbt.dataset.krFbtInit) return;
    fbt.dataset.krFbtInit = '1';

    var items = fbt.querySelectorAll('.kr-fbt__item');
    var totalEl = fbt.querySelector('#kr-fbt-total, [id^="kr-fbt-total"]') || fbt.querySelector('.kr-fbt__total-price');
    var addBtn = fbt.querySelector('.kr-fbt__add-btn');

    function recalcTotal() {
      var totalCents = 0;
      items.forEach(function (item) {
        var checkbox = item.querySelector('input[type="checkbox"]');
        var priceEl = item.querySelector('.kr-fbt__price');
        var included = checkbox ? checkbox.checked : true;
        item.classList.toggle('kr-fbt__item--excluded', !included);
        if (included && priceEl) {
          totalCents += parsePriceToCents(priceEl.textContent);
        }
      });
      if (totalEl) totalEl.textContent = formatMoney(totalCents);
      if (addBtn) {
        var anyChecked = Array.from(items).some(function (item) {
          var cb = item.querySelector('input[type="checkbox"]');
          return cb ? cb.checked : true;
        });
        addBtn.disabled = !anyChecked;
      }
    }

    items.forEach(function (item) {
      var checkbox = item.querySelector('.kr-fbt__checkbox');
      if (checkbox) {
        checkbox.addEventListener('change', recalcTotal);
      }
    });

    recalcTotal();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var itemsToAdd = [];

        items.forEach(function (item) {
          var checkbox = item.querySelector('input[type="checkbox"]');
          var included = checkbox ? checkbox.checked : true;
          if (!included) return;

          var variantId = item.getAttribute('data-variant-id');
          if (variantId) {
            itemsToAdd.push({ id: parseInt(variantId, 10), quantity: 1 });
          } else if (item.classList.contains('kr-fbt__item--main')) {
            var mainForm = document.querySelector('form[action^="/cart/add"]');
            var mainVariantInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
            if (mainVariantInput && mainVariantInput.value) {
              itemsToAdd.push({ id: parseInt(mainVariantInput.value, 10), quantity: 1 });
            }
          }
        });

        if (itemsToAdd.length === 0) return;

        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            addBtn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            addBtn.textContent = 'Error — try again';
            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 1800);
          });
      });
    }
  }

  function initAllFbt() {
    document.querySelectorAll('.kr-fbt').forEach(initFbt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFbt);
  } else {
    initAllFbt();
  }

  document.addEventListener('shopify:section:load', initAllFbt);
})();/* ============================================================
   Kruncho — Cart drawer: progress bar + cross-sell add-to-cart
   ============================================================ */

(function () {
  function formatRupees(cents) {
    return '₹' + Math.round(cents / 100);
  }

  function toTitleCase(str) {
  return str.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
}

  function updateProgress() {
    var wrap = document.getElementById('KrCartProgress');
    if (!wrap) return;

    var totalCents = parseInt(wrap.getAttribute('data-cart-total'), 10) || 0;
    var milestones = Array.from(wrap.querySelectorAll('.kr-cart-progress__milestone'))
      .map(function (el) {
        return { el: el, amount: parseInt(el.getAttribute('data-amount'), 10) };
      })
      .sort(function (a, b) { return a.amount - b.amount; });

    if (milestones.length === 0) return;

    var maxAmount = milestones[milestones.length - 1].amount;
    var fill = document.getElementById('KrCartProgressFill');
    var banner = document.getElementById('KrCartProgressBanner');

    var pct = Math.min(100, (totalCents / maxAmount) * 100);
    if (fill) fill.style.width = pct + '%';

    var nextMilestone = milestones.find(function (m) { return totalCents < m.amount; });

    milestones.forEach(function (m) {
      m.el.classList.toggle('kr-reached', totalCents >= m.amount);
    });

    if (banner) {
      if (nextMilestone) {
        var remaining = formatRupees(nextMilestone.amount - totalCents);
        var label = nextMilestone.el.querySelector('.kr-cart-progress__label').textContent.replace(/^[₹\d]+/, '').trim();
        banner.textContent = toTitleCase(remaining + ' away from ' + label);
      } else {
        banner.textContent = "You've Unlocked Free Shipping!";
      }
    }
  }

  function refreshCartData() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var wrap = document.getElementById('KrCartProgress');
        if (wrap) {
          wrap.setAttribute('data-cart-total', cart.total_price);
          updateProgress();
        }
      });
  }

  document.addEventListener('DOMContentLoaded', updateProgress);
  document.addEventListener('cart:refresh', refreshCartData);
  document.addEventListener('shopify:section:load', updateProgress);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kr-cross-add]');
    if (!btn) return;
    var card = btn.closest('.kr-cross-sell__card');
    var variantId = card ? card.getAttribute('data-variant-id') : null;
    if (!variantId) return;

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
      });
  });
})();(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kr-coupon-form]');
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector('#KrCouponInput');
    var code = input ? input.value.trim() : '';
    if (!code) return;

    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });
})();